// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-micro-down';

export const Component = () => <path d='M8 9.5h9l-4.402 6-4.597-6H8Z' />;

export const viewBox = '0 0 25 25';
